import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Table } from "react-bootstrap";
import { clearAllProductPriceAlerts, clearProductPriceAlert, fetchProductPriceAlerts } from "../api/api";

const normalizeList = (data) => Array.isArray(data) ? data : (data?.results || []);

const PriceAlertsBanner = ({ compact = false }) => {
    const [alerts, setAlerts] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadAlerts = useCallback(async () => {
        try {
            setLoading(true);
            const data = await fetchProductPriceAlerts();
            setAlerts(normalizeList(data));
        } catch (error) {
            console.error("Error loading product price alerts:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadAlerts();
    }, [loadAlerts]);

    const handleClear = async (alertId) => {
        await clearProductPriceAlert(alertId);
        setAlerts((current) => current.filter((alert) => alert.id !== alertId));
    };

    const handleClearAll = async () => {
        await clearAllProductPriceAlerts();
        setAlerts([]);
    };

    if (loading || alerts.length === 0) {
        return null;
    }

    return (
        <Alert variant="warning" className="price-alert-banner text-start">
            <div className="d-flex justify-content-between align-items-center gap-3 mb-2">
                <strong>Product Price Changes</strong>
                <Button variant="outline-dark" size="sm" onClick={handleClearAll}>
                    Clear all viewed
                </Button>
            </div>
            {compact ? (
                <div className="d-grid gap-2">
                    {alerts.slice(0, 3).map((alert) => (
                        <div key={alert.id} className="d-flex justify-content-between gap-2 align-items-start">
                            <span>{alert.summary}</span>
                            <Button variant="outline-dark" size="sm" onClick={() => handleClear(alert.id)}>
                                Clear
                            </Button>
                        </div>
                    ))}
                    {alerts.length > 3 && <small>{alerts.length - 3} more price changes are waiting.</small>}
                </div>
            ) : (
                <Table responsive size="sm" className="mb-0">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Base unit update</th>
                            <th>Highest alternative unit</th>
                            <th>Changed</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {alerts.map((alert) => (
                            <tr key={alert.id}>
                                <td>{alert.product_name}</td>
                                <td>
                                    {alert.base_unit_snapshot?.unit_name || "Base Unit"}: retail {alert.base_unit_snapshot?.retail_price}, wholesale {alert.base_unit_snapshot?.wholesale_price}
                                </td>
                                <td>
                                    {alert.highest_unit_snapshot?.unit_name
                                        ? `${alert.highest_unit_snapshot.unit_name}: retail ${alert.highest_unit_snapshot.retail_price}, wholesale ${alert.highest_unit_snapshot.wholesale_price}`
                                        : "No alternative units"}
                                </td>
                                <td>{new Date(alert.created_at).toLocaleString("en-GB")}</td>
                                <td className="text-end">
                                    <Button variant="outline-dark" size="sm" onClick={() => handleClear(alert.id)}>
                                        Clear
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Alert>
    );
};

export default PriceAlertsBanner;